import React from 'react'
import './footer.css'
import footer1 from './img/footer1.png'
import footer2 from './img/footer2.png'

function Footer() {
    return (
        <div className = 'footer'>
            <img className = 'footer_pic1' src = {footer2} alt = 'footer pic'/>
            <div className = 'footer_desc'>
                <h2>Made By Sanket Puhan</h2>
                <p>Copyright © 2021 All rights Reserved.</p>
            </div>
            <img className = 'footer_pic2' src = {footer1} alt = 'footer pic'/>
        </div>
    )
}

export default Footer
